import React from 'react'
import { CategoryManagementStyled } from './styled'
import {
  Button,
  Modal,
  Image,
  InputSearch,
  Paginate,
  Section,
  Table,
  Accordion,
  Input,
} from '../../components'
import { ICONS } from '../../themes'
import { ROUTE_PATH, STRING } from '../../helpers'

export class CategoryManagementContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isSortBy: [
        { name: 'id', value: undefined },
        { name: 'businessGroup', value: undefined },
      ],
      modals: [
        { name: 'delete', isOpen: false, Idlist: '', Fullname: '' },
        { name: 'error', isOpen: true },
      ],
      datas: [
        { id: '3110202032810', isOpen: true },
        { id: '3110202032811', isOpen: false },
      ],
    }
  }

  toggleSort = evt => {
    this.setState(prevState => ({
      ...prevState,
      isSortBy: prevState.isSortBy.map(column => ({
        ...column,
        value:
          column.name === evt
            ? column.value !== undefined
              ? column.value === 'asc'
                ? 'desc'
                : 'asc'
              : 'asc'
            : undefined,
      })),
    }))
  }

  filterSortByValue = evt => {
    return this.state.isSortBy
      .filter(columns => columns.name === evt)
      .map(column => column.value)[0]
  }

  toggleModal = (evt, id, name) => {
    evt.stopPropagation()
    this.setState(
      prevState => ({
        ...prevState,
        modals: prevState.modals.map(modal => ({
          ...modal,
          isOpen: modal.name === name ? !modal.isOpen : false,
          Idlist: id,
          Fullname: name,
        })),
      }),
      () => {
        // console.log(this.state.modals)
      }
    )
  }

  toggleDataAccordion = evtID => {
    this.setState(prevState => ({
      ...prevState,
      datas: prevState.datas.map(data => ({
        ...data,
        isOpen: data.id === evtID ? !data.isOpen : data.isOpen,
      })),
    }))
  }

  render() {
    const { modals, datas } = this.state

    return (
      <React.Fragment>
        <CategoryManagementStyled>
          {/* PAGE TITLE
          -----------------------------------------------------
          -----------------------------------------------------
          */}
          <Section className="page-topbar">
            <Section className="page-header">
              <Section className="page-icon">
                <Image
                  id="page_icon_category_management"
                  src={ICONS['icon-supplier-discovery-white.svg']}
                  alt="page icon"
                />
              </Section>

              <Section className="title-and-breadcrumb">
                <Section id="page_title_category_management" className="title">
                  {STRING.CATEGORY_MANAGEMENT}
                </Section>

                <Section
                  id="page_breadcrumb_category_management"
                  className="breadcrumbs"
                >
                  <Button
                    className="breadcrumb"
                    onClick={() => {
                      this.props.history.push(ROUTE_PATH.HOME.LINK)
                    }}
                  >
                    <span>{STRING.HOME}</span>
                  </Button>

                  <Button className="breadcrumb current">
                    <span>{STRING.CATEGORY_MANAGEMENT}</span>
                  </Button>
                </Section>
              </Section>
            </Section>

            <Section className="page-button">
              <Button className="page-button" onClick={() => {}}>
                {/* <Image src={ICONS['icon-add-circular.svg']} alt="add icon" /> */}
                Create Business Group
              </Button>

              <Button className="page-button" onClick={() => {}}>
                {/* <Image src={ICONS['icon-add-circular.svg']} alt="add icon" /> */}
                Create Service Group
              </Button>
            </Section>
          </Section>

          {/* PAGE CONTENT
          -----------------------------------------------------
          -----------------------------------------------------
          */}
          <Section className="main-content">
            <Section className="content-body">
              <Section className="table-filter">
                <InputSearch
                  id="filter_search_input"
                  placeholder="Business Group, Service & Item Group"
                />
              </Section>

              <Section className="table-wrapper">
                <Table className="category split-row-color">
                  {/* Header Row */}
                  <Table.THEAD>
                    <Table.TR className="header">
                      <Table.TH
                        className="id"
                        id="id_header"
                        isSortable={true}
                        sortBy={this.filterSortByValue('id')}
                        onClick={() => this.toggleSort('id')}
                      >
                        ID
                      </Table.TH>

                      <Table.TH
                        className="business-group"
                        id="business_group_header"
                        isSortable={true}
                        sortBy={this.filterSortByValue('businessGroup')}
                        onClick={() => this.toggleSort('businessGroup')}
                      >
                        BUSINESS GROUP
                      </Table.TH>

                      <Table.TH
                        className="service-and-item-group"
                        id="service_and_item_group_header"
                      >
                        SERVICE & ITEM GROUP
                      </Table.TH>

                      <Table.TH className="update-date" id="update_date_header">
                        UPDATE DATE
                      </Table.TH>

                      <Table.TH
                        className="created-date"
                        id="create_date_header"
                      >
                        CREATED DATE
                      </Table.TH>

                      <Table.TH className="actions" id="actions_header">
                        ACTIONS
                      </Table.TH>
                    </Table.TR>
                  </Table.THEAD>
                </Table>

                {/* Content Row */}
                <Accordion
                  className="accordion-table-data"
                  isOpen={
                    datas
                      .filter(modal => {
                        return modal.id === '3110202032810'
                      })
                      .map(obj => obj.isOpen)[0]
                  }
                >
                  <Accordion.Head
                    //onlyIconClickable
                    onClick={() => this.toggleDataAccordion('3110202032810')}
                  >
                    <Table className="category">
                      <Table.TBODY>
                        <Table.TR>
                          <Table.TD className="id">3110202032810</Table.TD>

                          <Table.TD className="business-group">
                            Business Group_1
                          </Table.TD>

                          <Table.TD className="service-and-item-group"></Table.TD>

                          <Table.TD className="update-date">
                            Oct 08, 2019 14:00
                          </Table.TD>

                          <Table.TD className="created-date">
                            Oct 08, 2019 14:00
                          </Table.TD>

                          <Table.TD className="actions">
                            <Section>
                              <Button className="link">
                                <Image
                                  className="edit-icon"
                                  src={ICONS['icon-edit.svg']}
                                  alt="edit"
                                />
                              </Button>

                              <Button
                                className="link"
                                onClick={evt =>
                                  this.toggleModal(evt, 1, 'delete')
                                }
                              >
                                <Image
                                  className="delete-icon"
                                  src={ICONS['icon-trash.svg']}
                                  alt="delete"
                                />
                              </Button>
                            </Section>
                          </Table.TD>
                        </Table.TR>
                      </Table.TBODY>
                    </Table>
                  </Accordion.Head>

                  <Accordion.Body>
                    <Table className="category">
                      <Table.TBODY>
                        <Table.TR>
                          <Table.TD className="id"></Table.TD>

                          <Table.TD className="business-group"></Table.TD>

                          <Table.TD className="service-and-item-group">
                            Service & Product Group_1
                          </Table.TD>

                          <Table.TD className="update-date">
                            Oct 08, 2019 14:00
                          </Table.TD>

                          <Table.TD className="created-date">
                            Oct 08, 2019 14:00
                          </Table.TD>

                          <Table.TD className="actions">
                            <Section>
                              <Button className="link">
                                <Image
                                  className="edit-icon"
                                  src={ICONS['icon-edit.svg']}
                                  alt="edit"
                                />
                              </Button>

                              <Button
                                className="link"
                                onClick={evt =>
                                  this.toggleModal(evt, 1, 'delete')
                                }
                              >
                                <Image
                                  className="delete-icon"
                                  src={ICONS['icon-trash.svg']}
                                  alt="delete"
                                />
                              </Button>
                            </Section>
                          </Table.TD>
                        </Table.TR>

                        <Table.TR>
                          <Table.TD className="id"></Table.TD>

                          <Table.TD className="business-group"></Table.TD>

                          <Table.TD className="service-and-item-group">
                            Service & Product Group_2
                          </Table.TD>

                          <Table.TD className="update-date">
                            Oct 08, 2019 14:00
                          </Table.TD>

                          <Table.TD className="created-date">
                            Oct 08, 2019 14:00
                          </Table.TD>

                          <Table.TD className="actions">
                            <Section>
                              <Button className="link">
                                <Image
                                  className="edit-icon"
                                  src={ICONS['icon-edit.svg']}
                                  alt="edit"
                                />
                              </Button>

                              <Button
                                className="link"
                                onClick={evt =>
                                  this.toggleModal(evt, 1, 'delete')
                                }
                              >
                                <Image
                                  className="delete-icon"
                                  src={ICONS['icon-trash.svg']}
                                  alt="delete"
                                />
                              </Button>
                            </Section>
                          </Table.TD>
                        </Table.TR>

                        <Table.TR>
                          <Table.TD className="id"></Table.TD>

                          <Table.TD className="business-group"></Table.TD>

                          <Table.TD className="service-and-item-group">
                            Service & Product Group_3
                          </Table.TD>

                          <Table.TD className="update-date">
                            Oct 08, 2019 14:00
                          </Table.TD>

                          <Table.TD className="created-date">
                            Oct 08, 2019 14:00
                          </Table.TD>

                          <Table.TD className="actions">
                            <Section>
                              <Button className="link">
                                <Image
                                  className="edit-icon"
                                  src={ICONS['icon-edit.svg']}
                                  alt="edit"
                                />
                              </Button>

                              <Button
                                className="link"
                                onClick={evt =>
                                  this.toggleModal(evt, 1, 'delete')
                                }
                              >
                                <Image
                                  className="delete-icon"
                                  src={ICONS['icon-trash.svg']}
                                  alt="delete"
                                />
                              </Button>
                            </Section>
                          </Table.TD>
                        </Table.TR>
                      </Table.TBODY>
                    </Table>
                  </Accordion.Body>
                </Accordion>

                <Accordion
                  className="accordion-table-data"
                  isOpen={
                    datas
                      .filter(modal => {
                        return modal.id === '3110202032811'
                      })
                      .map(obj => obj.isOpen)[0]
                  }
                >
                  <Accordion.Head
                    //onlyIconClickable
                    onClick={() => this.toggleDataAccordion('3110202032811')}
                  >
                    <Table className="category">
                      <Table.TBODY>
                        <Table.TR>
                          <Table.TD className="id">3110202032811</Table.TD>

                          <Table.TD className="business-group">
                            Business Group_1
                          </Table.TD>

                          <Table.TD className="service-and-item-group"></Table.TD>

                          <Table.TD className="update-date">
                            Oct 08, 2019 14:00
                          </Table.TD>

                          <Table.TD className="created-date">
                            Oct 08, 2019 14:00
                          </Table.TD>

                          <Table.TD className="actions">
                            <Section>
                              <Button className="link">
                                <Image
                                  className="edit-icon"
                                  src={ICONS['icon-edit.svg']}
                                  alt="edit"
                                />
                              </Button>

                              <Button
                                className="link"
                                onClick={evt =>
                                  this.toggleModal(evt, 1, 'delete')
                                }
                              >
                                <Image
                                  className="delete-icon"
                                  src={ICONS['icon-trash.svg']}
                                  alt="delete"
                                />
                              </Button>
                            </Section>
                          </Table.TD>
                        </Table.TR>
                      </Table.TBODY>
                    </Table>
                  </Accordion.Head>

                  <Accordion.Body>
                    <Table className="category">
                      <Table.TBODY>
                        <Table.TR>
                          <Table.TD className="id"></Table.TD>

                          <Table.TD className="business-group"></Table.TD>

                          <Table.TD className="service-and-item-group">
                            Service & Product Group_1
                          </Table.TD>

                          <Table.TD className="update-date">
                            Oct 08, 2019 14:00
                          </Table.TD>

                          <Table.TD className="created-date">
                            Oct 08, 2019 14:00
                          </Table.TD>

                          <Table.TD className="actions">
                            <Section>
                              <Button className="link">
                                <Image
                                  className="edit-icon"
                                  src={ICONS['icon-edit.svg']}
                                  alt="edit"
                                />
                              </Button>

                              <Button
                                className="link"
                                onClick={evt =>
                                  this.toggleModal(evt, 1, 'delete')
                                }
                              >
                                <Image
                                  className="delete-icon"
                                  src={ICONS['icon-trash.svg']}
                                  alt="delete"
                                />
                              </Button>
                            </Section>
                          </Table.TD>
                        </Table.TR>
                      </Table.TBODY>
                    </Table>
                  </Accordion.Body>
                </Accordion>
              </Section>
            </Section>

            <Section className="content-footer">
              <Section className="showing-item">
                Showing 1 to 10 of 60 entries
              </Section>

              <Section className="paginate-wrapper">
                <Paginate
                  activePage={1}
                  itemsCountPerPage={10}
                  totalItemsCount={450}
                  pageRangeDisplayed={5}
                  // onChange={() => ({})}
                />

                <Section className="moveto-wrapper">
                  <Input
                    className="paginate-moveto"
                    label="Page"
                    defaultValue="1"
                    isHorizontal
                    maxLength="4"
                  />

                  <Button>go</Button>
                </Section>
              </Section>
            </Section>
          </Section>
        </CategoryManagementStyled>

        <Modal
          id="delete_id"
          className="theme-blue"
          isOpen={
            modals
              .filter(modal => {
                return modal.name === 'delete'
              })
              .map(obj => obj.isOpen)[0]
          }
          modalWidth="575px"
        >
          <Modal.Header>Delete</Modal.Header>

          <Modal.Body>
            <p className="default text-center">
              Are you sure to delete? <br />
              {modals[0].FullName}
            </p>
          </Modal.Body>

          <Modal.Footer>
            <Button
              id="close_modal_history_id"
              className="theme-border-gray"
              onClick={evt => this.toggleModal(evt, 'delete')}
            >
              Cancel
            </Button>

            <Button
              id="close_modal_history_id"
              className="theme-green"
              onClick={() => {
                this.deleteList()
              }}
            >
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>

        {/* use same warning popup to pop message */}
        <Modal
          id="popup_warning_modal"
          className="popup warning theme-yellow"
          isOpen={
            modals
              .filter(modal => {
                return modal.name === 'error'
              })
              .map(obj => obj.isOpen)[0]
          }
        >
          <Modal.Header>Error</Modal.Header>

          <Modal.Body>
            <Image src={ICONS['icon-warning.svg']} className="warning" />

            <div className="warning-msg">
              cannot delete Business Group_1 and Service & Product Group_1
              because there is some company still choose it.
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              id="cancel_request_esg_modal"
              className="theme-border-gray close"
              onClick={evt => this.toggleModal(evt, 'error')}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    )
  }
}
